import { render, staticRenderFns } from "./PropertyWaterConsumption.vue?vue&type=template&id=57f4e0b8&lang=pug&"
import script from "./PropertyWaterConsumption.vue?vue&type=script&lang=ts&"
export * from "./PropertyWaterConsumption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports